// src/pages/Login.js

import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import '../Home/Home.css';
import '../Auth.css';

function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const history = useHistory(); // Used for redirecting

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const raw = await response.text();
      let data = {};
      try {
        data = raw ? JSON.parse(raw) : {};
      } catch (parseErr) {
        data = {};
      }
      
      if (response.ok) {
        setMessage('Login successful!');
        if (!data.token) {
          throw new Error('Login response missing token.');
        }
        onLogin(data.token);
        history.push('/control-panel');
      } else {
        const fallback = raw && raw.trim().length ? raw : 'Login failed.';
        setMessage(data.message || fallback);
      }
    } catch (error) {
      setMessage('An error occurred during login. Please try again later.');
      console.error('Login error:', error);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            required
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
          />
          <button type="submit">Login</button>
        </form>
        {message && <p>{message}</p>}
      </div>
    </div>
  );
}

export default Login;
